import ClaimTypeEnum from '@js/enums/damage/ClaimTypeEnum';
import ClaimTypeComprehensiveEnum from '@js/enums/damage/ClaimTypeComprehensiveEnum';

interface AddressComponent {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  long_name: string,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  short_name: string,
  types: string[]
}

interface DamageAttributesInterface {
  accidentAddressComponents: AddressComponent[];
  accidentDateTime: string | null;
  accidentPlace: string;
  carRentalSource: string | null;
  deliveryFirmId: number | null;
  deliveryReceiptNumber: string | null;
  deliveryTime: string;
  descriptionAccident: string;
  isRecordedByPolice: string;
  isRentalCarUsed: string;
}

interface DamageDataInterface {
  attributes: DamageAttributesInterface;
}

interface DamageInterface {
  data: DamageDataInterface;
}

interface RecordDataAttributesInterface {
  adversary: any;
  claimType: any;
  comprehensiveInsurancePolicy: any;
  customer: any;
  customerId: string | null;
  damage: DamageInterface;
  differingPolicyholder: any;
  firmId: number | null;
  isFleetOrMajorCustomer: boolean;
  isPrivacyPolicyAcknowledged: boolean;
  lawyerId: number | null;
  minimalRecordCreation: boolean;
  note: string | null;
  recordCreationByCustomer: boolean;
  selectedTab: string;
  uploadSessionId: string;
  vehicle: any;
}

interface RecordDataInterface {
  attributes: RecordDataAttributesInterface
}

export default class RecordNewSkeletton {
  public data: RecordDataInterface = {
    attributes: {
      firmId: null,
      lawyerId: null,
      selectedTab: '',
      customerId: null,
      uploadSessionId: '',
      minimalRecordCreation: false,
      recordCreationByCustomer: false,
      isPrivacyPolicyAcknowledged: false,
      isFleetOrMajorCustomer: false,
      note: null,
      claimType: {
        data: {
          attributes: {
            insuranceType: ClaimTypeEnum.CASUALTY,
            insuranceComprehensiveType: ClaimTypeComprehensiveEnum.FULLY,
            hasDifferingPolicyholder: false,
          },
        },
      },
      damage: {
        data: {
          attributes: {
            accidentAddressComponents: [],
            accidentDateTime: null,
            accidentPlace: '',
            carRentalSource: null,
            deliveryFirmId: null,
            deliveryReceiptNumber: null,
            deliveryTime: '',
            descriptionAccident: '',
            isRecordedByPolice: 'void',
            isRentalCarUsed: 'void',
          },
        },
      },
      customer: {
        data: {
          attributes: {
            gender: '',
            firstName: '',
            lastName: '',
            companyName: '',
            street: '',
            postalCode: '',
            place: '',
            phoneGeneric: '',
            phoneType: 'mobile',
            email: '',
            iban: '',
            isCustomerDeductingVatEntitled: 'void',
            customerNumber: '',
            orderNumber: null,
            isFirstPartyDamage: false,
          },
        },
      },
      vehicle: {
        data: {
          attributes: {
            automaticVehicleInsert: false,
            vin: '',
            licensePlate: '',
            model: '',
            registrationDate: '',
            mileage: '',
            deliveredVehicleType: null,
          },
        },
      },
      adversary: {
        data: {
          attributes: {
            gender: '',
            firstName: '',
            lastName: '',
            companyName: '',
            cargo: '',
            adversaryInsuranceReference: '',
            insurancePolicy: {
              data: {
                attributes: {
                  parentInsuranceId: 0,
                  insuranceId: 0,
                },
              },
            },
          },
        },
      },
      comprehensiveInsurancePolicy: {
        data: {
          attributes: {
            parentInsuranceId: 0,
            partialCoverage: 'void',
            partialCoverageCopayment: '',
            comprehensive: 'void',
            comprehensiveCopayment: '',
            insurancePolicyNr: '',
            adversaryInsuranceReference: '',
          },
        },
      },
      differingPolicyholder: {
        data: {
          attributes: {
            gender: '',
            firstName: '',
            lastName: '',
            companyName: '',
            street: '',
            postalCode: '',
            place: '',
            mobile: '',
            email: '',
          },
        },
      },
    },
  };

  public constructor() {
    this.data.attributes.uploadSessionId = [...crypto.getRandomValues(new Uint8Array(20))]
      .map(m => ('0' + m.toString(16)).slice(-2)).join('');

    this.data.attributes.customer.data.attributes.customerNumber = null;
    this.data.attributes.adversary.data.attributes.insurancePolicy.data.attributes.parentInsuranceId = null;
    this.data.attributes.adversary.data.attributes.insurancePolicy.data.attributes.insuranceId = null;
  }
}
